import { render } from "./UserScoreCard.vue?vue&type=template&id=9d8bcd4a"
import script from "./UserScoreCard.vue?vue&type=script&lang=js"
export * from "./UserScoreCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__